var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "mb-20 px-4", attrs: { flat: "" } },
    [
      _c(
        "v-layout",
        { attrs: { column: "", "justify-center": "" } },
        [
          _c(
            "v-card-title",
            { attrs: { "primary-title": "" } },
            [
              _c("v-icon", { staticClass: "mr-5", attrs: { color: "black" } }, [
                _vm._v("account_circle")
              ]),
              _vm._v(" "),
              _c("h2", { staticClass: "font-weight-thin mr-10" }, [
                _vm._v("Conta")
              ]),
              _vm._v(" "),
              _c("status", {
                attrs: {
                  status: _vm.getStatus(_vm.account.status),
                  statuses: _vm.getStatuses()
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("v-divider"),
          _vm._v(" "),
          _c("attributes", {
            attrs: { account: _vm.account },
            on: {
              refresh: function($event) {
                return _vm.$emit("refresh")
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-11641c7e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11641c7e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/Users/Account/Index.vue
// module id = null
// module chunks = 